// Firebase.js
import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';  // Import the database service
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.REACT_APP_DATABASE_URL,
    projectId: process.env.REACT_APP_PROJECT_ID,
    storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_APP_ID,
    measurementId: process.env.REACT_APP_MEASUREMENT_ID
};

// Create a promise for initializeApp
const initializeFirebase = async () => {
    try {
      const app = initializeApp(firebaseConfig);
      return app; // Resolve with the initialized app
    } catch (error) {
      console.error('Error initializing Firebase:', error);
      throw error;
    }
  };
  
  // Initialize Firebase
  let app; // Declare app outside the scope
  let db; // Declare db outside the scope
  let analytics; // Declare analytics outside the scope
  
  (async () => {
    try {
      app = await initializeFirebase(); // Assign app here
      db = getDatabase(app); // Assign db here
      analytics = getAnalytics(app); // Assign analytics here
      // Your code that depends on app, db, and analytics...
    } catch (error) {
      console.error('Error during initialization:', error);
    }
  })();
  
  // Export the initialized objects
  export { app, db, analytics };